import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_SELLERS_LIST = gql`
  {
    getSellers {
      sellerSlugName
      sellerName
      logo {
        es
        en
        ca
      }
      priority
      postUri
      url
    }
  }
`;

const getSellers = async () => {
  try {
    const result = await client
      .query({
        query: GET_SELLERS_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getSellers: sellersListData },
    } = result;

    if (sellersListData) {
      return sellersListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getSellers = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getSellers Error: ${error}`);
    return null;
  }
};

export default getSellers;
